<template>
    <label class="checkbox"
           v-if="weekday"
           :key="date"
    >
        <input type="checkbox" v-model="isChecked">
        {{ weekday }} [{{ label }}]
    </label>
</template>

<script>
    export default {
        props: ['label', 'date', 'weekday'],
        computed: {
            isChecked: {
                get() {
                    return this.$store.getters.getQueryDatesByDateStock(this.date).length !== 0
                },
                set(value) {
                    if (this.$store.getters.getQueryDatesByDateStock(this.date).length === 0) {
                        this.$store.dispatch('addDateToQueryStock', this.date)
                    } else {
                        this.$store.dispatch('removeDateFromQueryStock', this.date)
                    }
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/StockCars/DayStockCar.vue